import { customAxios, type ErrorResponse } from '@/shared/lib/customAxios';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

// POST /login/web/signin ------------------------------ login

export interface LoginRequest {
	grantType: 'phone' | 'email';
	id: string;
	password: string;
	language: 'en' | 'kh';
}

export interface LoginResponse {
	angkorId: string;
	token: string;
}

export const postLogin = async (
	request: LoginRequest
): Promise<LoginResponse> => {
	const { language, ...requestDto } = request;

	const response = await customAxios.post<LoginResponse>(
		'login/web/signin',
		requestDto,
		{
			headers: {
				Language: language,
			},
		}
	);

	return response.data;
};

export const useLoginMutation = (): UseMutationResult<
	LoginResponse,
	AxiosError<ErrorResponse>,
	LoginRequest,
	unknown
> => {
	return useMutation<
		LoginResponse,
		AxiosError<ErrorResponse>,
		LoginRequest,
		unknown
	>({
		mutationFn: postLogin,
	});
};

// POST /login/web/signin ------------------------------ login
